import { render } from "./CardPerson.vue?vue&type=template&id=0f41273a&scoped=true"
import script from "./CardPerson.vue?vue&type=script&lang=js"
export * from "./CardPerson.vue?vue&type=script&lang=js"

import "./CardPerson.vue?vue&type=style&index=0&id=0f41273a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f41273a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCircularProgress,QImg,QIcon,QTooltip});
